function columnarLinkedList<Type>(linkList: Type[], numOfColumns: number = 1): Type[][] {
  if (numOfColumns < 1) throw new Error('Number of columns must be greater than 0!');

  return linkList.reduce<Type[][]>((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / numOfColumns);
    const resultArrayCopy = resultArray;

    if (!resultArrayCopy[chunkIndex]) {
      resultArrayCopy[chunkIndex] = new Array<Type>(); // start a new chunk
    }

    resultArrayCopy[chunkIndex].push(item);

    return resultArrayCopy;
  }, []);
}

export default columnarLinkedList;
